import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ThemeToggle = () => {
  const { t } = useTranslation();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  // Apply theme on component mount
  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
  }, [theme]);

  // Handle theme toggle
  const toggleTheme = (e) => {
    e.preventDefault();
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-bs-theme', newTheme);
  };

  return (
    <div className="nav-item d-flex me-2">
      {/* Show in light mode, hide in dark mode */}
      <a
        href="#"
        className="nav-link px-0 hide-theme-dark"
        onClick={toggleTheme}
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        aria-label={t('components.theme.switchToDark', 'Switch to dark mode')}
        data-bs-original-title={t('components.theme.switchToDark', 'Switch to dark mode')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon">
          <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
          <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"></path>
        </svg>
      </a>

      {/* Show in dark mode, hide in light mode */}
      <a
        href="#"
        className="nav-link px-0 hide-theme-light"
        onClick={toggleTheme}
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        aria-label={t('components.theme.switchToLight', 'Switch to light mode')}
        data-bs-original-title={t('components.theme.switchToLight', 'Switch to light mode')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"></path>
        </svg>
      </a>
    </div>
  );
};

export default ThemeToggle;
